import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  postStatProduitsAction,
  resetResponseProduitsAction,
  resetSearchContenudestinationAction,
  resetSelectProduitAction,
  searchProduitsAction,
  selectProduitAction,
} from 'src/app/stores/actions/produits.actions';
import { offSpinner, onSpinner } from 'src/app/stores/actions/site.actions';
import {
  contenudestination,
  produit,
} from 'src/app/stores/interfaces/produits.interface';
import {
  CONTENUDESTINATION_INIT_STATE,
  RESPONSE_PRODUIT_INIT_STATE,
} from 'src/app/stores/reducers/produits.reducer';
import {
  selectProduit,
  selectProduits,
} from 'src/app/stores/selectors/produits.selectors';
import { environment } from 'src/environments/environment';

import { getLink } from 'src/app/stores/utils';

@Component({
  selector: 'app-produit',
  templateUrl: './produit.component.html',
  styleUrls: ['./produit.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProduitComponent implements OnInit {
  produit: produit = RESPONSE_PRODUIT_INIT_STATE;
  related: produit[] = [];
  destination: contenudestination = CONTENUDESTINATION_INIT_STATE;
  urlReferrer: string = '';
  urlCurrent: string = '';
  urlLogo: string = '';
  titre: string = '';
  categorie: string = '';
  destinationLink: string = '';
  tag: string = '';
  getLink = getLink;

  constructor(
    private readonly store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private meta: Meta,
    private title: Title,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {
    this.urlLogo = `${environment.logo}`;
    this.store.dispatch(
      selectProduitAction({
        id: this.route.snapshot.paramMap.get('id') ?? '',
      })
    );
    this.store.select(selectProduit).subscribe((produit) => {
      if (isPlatformBrowser(this._platformId)) {
        if (!sessionStorage.getItem(produit.idProduit) && produit.idProduit) {
          this.store.dispatch(
            postStatProduitsAction({
              ...produit,
              typeClick: 'CL',
              urlReferer: this.urlReferrer,
            })
          );
          sessionStorage.setItem(
            produit.idProduit,
            JSON.stringify({ ...produit })
          );
        }
      }
      this.produit = {
        ...produit,
        description: this.transformeReturnLine(produit.description),
      };
      this.formatMetadata();
      this.related = [];
      if (produit.destination) {
        this.destination = {
          ...this.destination,
          destination: produit.destination,
        };
      }
      if (produit.nomProduit) {
        this.store.dispatch(
          searchProduitsAction({
            page:"relativate",
            destination: produit.destination,
            categorie: produit.categorie,
            take: 13,
            skip: 0,
          })
        );
        this.store.dispatch(onSpinner());
      }
    });

    this.store.select(selectProduits).subscribe((p: produit[]) => {
      this.related = [
        ...p.filter((prd) => {
          return prd.idProduit !== this.produit.idProduit;
        }),
      ];
      this.store.dispatch(offSpinner());
    });
  }
  tags(tags: string[]) {
    return tags.length > 0 ? tags.join(' - ') : '';
  }
  clickStatistique() {
    if (isPlatformBrowser(this._platformId)) {
      this.store.dispatch(
        postStatProduitsAction({
          ...this.produit,
          typeClick: 'OP',
          urlReferer: this.urlReferrer,
        })
      );
    }
  }

  transformeReturnLine(texte: string) {
    return texte.replace(/\\n./g, '<br>');
  }
  transformeEscapeBackSlash(texte: string) {
    return texte.replace('//./g', '%2F');
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.urlReferrer = sessionStorage.getItem('currentUrl') ?? '';
      sessionStorage.setItem('currentUrl', this.router.url);
    }
  }

  ngOnDestroy(): void {
    this.store.dispatch(resetSearchContenudestinationAction());
    this.store.dispatch(resetResponseProduitsAction());
    this.store.dispatch(resetSelectProduitAction());
    this.produit = RESPONSE_PRODUIT_INIT_STATE;
    this.related = [];
  }
  formatMetadata() {
    let desc = '';
    const regex = /X{2}/g;
    this.titre = `${this.produit.nomProduit} - sechapper.com`;
    desc = `${this.produit.nomProduit} - `;
    desc += `${this.produit.nameCategorie} - `;
    desc += `${this.produit.tags.join(' - ')}`;
    this.meta.updateTag({
      name: 'description',
      content: desc,
    });
    this.meta.updateTag({
      name: 'robots',
      content: 'noindex',
    });
    this.title.setTitle(this.titre);
  }
}
